<script>
export default {
  name: "DidoApidocExamplesProcess",
};
</script>

<script setup>
import DidoCodeHightlighting from "../codeHighlighting/Base.vue";

const codeRequestAllDatasets =
  'curl "$BASE_URL_API/datasets?page=1&pageSize=all"';

const codeRequestFilterPhytoDatasets =
  "curl \"$BASE_URL_API/datasets?page=1&pageSize=all\" | jq -c '.data[] | select( .title | contains(\"phytosanitaire\")) | {id, title}' | jq -s '.'";
const codeResponseFilterPhytoDatasets = `[
  {
    "id": "64394162329d458db52e7189",
    "title": "Achats de produits phytosanitaires au code postal"
  },
  {
    "id": "64394106723e32063d3a165a",
    "title": "Achats et ventes de produits phytosanitaires à l'échelle départementale"
  }
]`;

const codeRequestDetailPhytoDataset =
  "curl \"$BASE_URL_API/datasets/64394162329d458db52e7189\" | jq -c '{id, title, datafiles:[.datafiles[] | {rid, title, millesimes:[.millesimes[] | .millesime]}]}' | jq '.'";
const codeResponseDetailPhytoDataset = `{
  "id": "64394162329d458db52e7189",
  "title": "Achats de produits phytosanitaires au code postal ",
  "datafiles": [
    {
      "rid": "c54f22e4-ad76-4594-bdc9-dafc61df7b2c",
      "title": "Achats de produits phytopharmaceutiques au code postal ",
      "millesimes": [
        "2021-12"
      ]
    }
  ]
}`;

const codeRequestDetailPhytoMillesime =
  "curl \"$BASE_URL_API/datafiles/c54f22e4-ad76-4594-bdc9-dafc61df7b2c?millesime=2021-12\" | jq -c '.columns[] | { name, filters }' | jq -s '.'";
const codeResponseDetailPhytoMillesime = `[
  {
    "name": "ANNEE",
    "filters": [
      "contains",
      "eq",
      "ne",
      "startsWith",
      "endsWith",
      "in",
      "nin"
    ]
  },
  { ... },
  {
    "name": "CODE_POSTAL",
    "filters": [
      "contains",
      "eq",
      "ne",
      "startsWith",
      "endsWith",
      "in",
      "nin"
    ]
  },
  {
    "name": "SUBSTANCE",
    "filters": [
      "contains",
      "eq",
      "ne",
      "startsWith",
      "endsWith",
      "in",
      "nin"
    ]
  },
  { ... }
]`;

const codeRequestRowsMillesime = `curl "$BASE_URL_API/datafiles/c54f22e4-ad76-4594-bdc9-dafc61df7b2c/rows\\
?millesime=2021-12\\
&page=1&pageSize=10\\
&orderBy=-QUANTITE_SUBSTANCE\\
&columns=QUANTITE_SUBSTANCE\\
&ANNEE=eq:2020\\
&CODE_POSTAL=eq:33600\\
&SUBSTANCE=eq:glyphosate"\\
| jq -c '.data[] | .QUANTITE_SUBSTANCE'`;
const codeResponseRowsMillesime = `80.1
43.2
21.6
9
7.2
6.525
5.4
3.75
3.6
0.576`;

const codeRequestExportXlsxMillesime = `curl "$BASE_URL_API/datafiles/c54f22e4-ad76-4594-bdc9-dafc61df7b2c/xlsx\\
?millesime=2021-12\\
&withColumnName=true\\
&withColumnDescription=false\\
&withColumnUnit=false\\
&ANNEE=eq:2021\\
&CODE_DEPARTEMENT=eq:33\\
&SUBSTANCE=eq:glyphosate" -o glypho_gironde.xlsx\\`;
</script>

<template>
  <div class="q-mt-md">
    <QExpansionItem
      id="example_all_datasets"
      label="4.3.1 - Récupérer les jeux de données"
      header-class="text-subtitle2 bg-grey-1"
      dense
      class="q-mt-sm q-ml-md"
    >
      <div class="q-mt-xs q-ml-md q-pl-lg text-caption dido-bordered-secondary">
        On peut commencer par interroger l'api pour récupérer l'ensemble des
        jeux de données :
        <DidoCodeHightlighting
          :code="codeRequestAllDatasets"
          language="shell"
        />

        Cette commande renvoie l'ensemble des jeux de données au format json
        donc la réponse est difficilement exploitable.
      </div>
    </QExpansionItem>
    <QExpansionItem
      id="example_filter_datasets"
      label="4.3.2 - Filtrer les jeux de données"
      header-class="text-subtitle2 bg-grey-1"
      dense
      class="q-mt-sm q-ml-md"
    >
      <div class="q-mt-xs q-ml-md q-pl-lg text-caption dido-bordered-secondary">
        On peut filtrer les jeux de données renvoyés grâce à jq.
        <br /><br />
        Par exemple pour obtenir les jeux de données qui contiennent le mot
        "phytosanitaire" dans le titre et ne récupérer que le titre et
        l'identifiant des jeux de données :
        <DidoCodeHightlighting
          :code="codeRequestFilterPhytoDatasets"
          language="shell"
        />
        On obtient ainsi une liste de jeux de données avec leur titre et leur
        identifiant :
        <DidoCodeHightlighting
          :code="codeResponseFilterPhytoDatasets"
          language="javascript"
        />
      </div>
    </QExpansionItem>
    <QExpansionItem
      id="example_detail_dataset"
      label="4.3.3 - Récupérer les informations d'un jeu de données"
      header-class="text-subtitle2 bg-grey-1"
      dense
      class="q-mt-sm q-ml-md"
    >
      <div class="q-mt-xs q-ml-md q-pl-lg text-caption dido-bordered-secondary">
        On peut maintenant obtenir le détail d'un jeu de données dont on connaît
        l'identifiant.
        <br /><br />
        Par exemple pour le jeu de données "Achats de produits
        phytopharmaceutiques au code postal", l'identifiant est
        "64394162329d458db52e7189".
        <br /><br />
        On peut récupérer son titre, sa description et la liste de ses fichiers
        de données (titre, identifiant et liste des millésimes) :
        <DidoCodeHightlighting
          :code="codeRequestDetailPhytoDataset"
          language="shell"
        />
        On obtient ainsi les infromations demandées sur le jeu de données :
        <DidoCodeHightlighting
          :code="codeResponseDetailPhytoDataset"
          language="javascript"
        />
      </div>
    </QExpansionItem>
    <QExpansionItem
      id="example_metadata_millesime"
      label="4.3.4 - Récupérer les infos de colonnes d'un millésime"
      header-class="text-subtitle2 bg-grey-1"
      dense
      class="q-mt-sm q-ml-md"
    >
      <div class="q-mt-xs q-ml-md q-pl-lg text-caption dido-bordered-secondary">
        Nous allons maintenant utiliser l'api pour obtenir des informations sur
        le millesime 2021-12 du fichier de données
        c54f22e4-ad76-4594-bdc9-dafc61df7b2c.
        <br /><br />
        Par exemple, on va récupérer la liste des colonnes (leur nom et les
        filtres disponibles) :
        <DidoCodeHightlighting
          :code="codeRequestDetailPhytoMillesime"
          language="shell"
        />
        Et on obtient le résultat suivant (nous avons volontairement omis un
        certain nombre de colonnes dans le résultat) :
        <DidoCodeHightlighting
          :code="codeResponseDetailPhytoMillesime"
          language="javascript"
        />
      </div>
    </QExpansionItem>
    <QExpansionItem
      id="example__data_millesime"
      label="4.3.5 - Filtrer les données d'un millésime"
      header-class="text-subtitle2 bg-grey-1"
      dense
      class="q-mt-sm q-ml-md"
    >
      <div class="q-mt-xs q-ml-md q-pl-lg text-caption dido-bordered-secondary">
        Maintenant que nous avons les informations sur les colonnes et notamment
        les filtres disponibles, nous allons utiliser l'api pour récupérer des
        données selon certains critères.
        <br /><br />
        Nous souhaitons avoir la liste des 10 plus importants achats de
        glyphosate sur la commune de Pessac en 2020 :
        <DidoCodeHightlighting
          :code="codeRequestRowsMillesime"
          language="shell"
        />
        On obtient le résultat suivant :
        <DidoCodeHightlighting
          :code="codeResponseRowsMillesime"
          language="shell"
        />
      </div>
    </QExpansionItem>
    <QExpansionItem
      id="example_export_millesime"
      label="4.3.6 - Exporter les données d'un millésime en xlsx"
      header-class="text-subtitle2 bg-grey-1"
      dense
      class="q-mt-sm q-ml-md"
    >
      <div class="q-mt-xs q-ml-md q-pl-lg text-caption dido-bordered-secondary">
        Enfin pour finir, l'api permet d'exporter les données d'un millésime
        dans différents formats.
        <br /><br />
        Ainsi, pour avoir un export csv (avec le libellé des colonnes comme
        en-têtes) des achats de glyphosate dans le département de la Gironde en
        2021 qui sera enregistré dans un fichier glypho_gironde.xlsx :
        <DidoCodeHightlighting
          :code="codeRequestExportXlsxMillesime"
          language="shell"
        />
      </div>
    </QExpansionItem>
  </div>
</template>

<style lang="sass" scoped>
.dido-bordered-secondary
  border-left: 4px solid var(--q-secondary)
</style>
